import { AccountService } from 'src/app/services/auth/account.service';
import { Component, HostListener, OnInit, OnDestroy, ViewChild } from '@angular/core';
import { MenuService } from 'src/app/services/menu.service';
import { RootMenuItem } from 'src/models/Menu';
import { Observable, Subscription } from 'rxjs';
import { CurrentUiStoreService } from 'src/app/services/ui/current-ui-store.service';
import { CurrentUIState } from 'src/models/UIState';
import { AsgardFeatureNames } from 'src/models/AsgardFeatures';
import { ModalWindowsTypes } from 'src/app/core/enums';
import { SettingsService } from '../../services/settings/settings.service';
import { ReadingMode } from '../../core/reading-utils/enums';
import { ReadingModesService } from 'src/app/services/reading-modes.service';
// import { MatDrawer } from '@angular/material/sidenav';
import { AutosaveManagerService } from 'src/app/services/autosave/autosave-manager.service';
import { DeviceDetectorService, ScreenDimensions } from 'src/app/services/device-detector.service';
import { HighlighterFloatingMenuComponent } from 'src/app/components/floating-menus/highlighter-floating-menu/highlighter-floating-menu.component';
import { DrawingToolsFloatingMenuComponent } from 'src/app/components/floating-menus/drawing-tools-floating-menu/drawing-tools-floating-menu.component';
import { ToolbarFloatingMenuComponent } from 'src/app/components/floating-menus/toolbar-floating-menu/toolbar-floating-menu.component';
import { ResponsiveUIBreakpoints } from 'src/app/utils/enums/responsive-ui-breakpoints.enum';
import { ExamModeRestrictionsService } from 'src/app/services/exam/exam-mode-restrictions.service';
import { LicenseService } from 'src/app/services/license.service';
import { ExamCommunicationService } from 'src/app/services/exam/exam-communication.service';
import { AuthService } from 'src/app/services/auth/auth.service';
import { CerberusRoles } from 'src/app/services/auth/cerberus-roles.enum';
import { PlatformDetectionService } from 'src/app/services/platform-detection.service';
import { KeyInfoComponent } from '../../components/examMode/key-info/key-info.component';
import { ExamTamperProtectionComponent } from '../../components/exam-tamper-protection/exam-tamper-protection.component';
import { KeyboardEventHandlerComponent } from '../../components/keyboard-event-handler/keyboard-event-handler.component';
import { AsgardCustomInputIframeComponent } from '../../components/asgard-custom-input-iframe/asgard-custom-input-iframe.component';
import { WordPredictorDialogComponent } from '../../components/dialogs/word-predictor-dialog/word-predictor-dialog.component';
import { MarkUpFloatingMenuComponent } from '../../components/floating-menus/mark-up-floating-menu/mark-up-floating-menu.component';
import { HighlighterFloatingMenuComponent as HighlighterFloatingMenuComponent_1 } from '../../components/floating-menus/highlighter-floating-menu/highlighter-floating-menu.component';
import { SearchFloatingMenuComponent } from '../../components/floating-menus/search-floating-menu/search-floating-menu.component';
import { DrawingToolsFloatingMenuComponent as DrawingToolsFloatingMenuComponent_1 } from '../../components/floating-menus/drawing-tools-floating-menu/drawing-tools-floating-menu.component';
import { SpeechRecognitionFloatingMenuComponent } from '../../components/floating-menus/speech-recognition-floating-menu/speech-recognition-floating-menu.component';
import { ToolbarFloatingMenuComponent as ToolbarFloatingMenuComponent_1 } from '../../components/floating-menus/toolbar-floating-menu/toolbar-floating-menu.component';
import { PaneListComponent } from '../../components/pane-list/pane-list.component';
import { ReadingToolbarComponent } from '../../components/reading-toolbar/reading-toolbar.component';
import { DesktopMenuItemComponent } from '../desktop-menu-item/desktop-menu-item.component';
import { MenuItemAdjusterDirective } from '../../utils/directives/menu-item-adjuster.directive';
import { TooltipDirective } from '../../utils/directives/tooltip.directive';
import { DropdownComponent } from '../../components/dropdown/dropdown.component';
import { NgClass } from '@angular/common';
import { ExamModeFloatingMenuComponent } from 'src/app/components/floating-menus/exam-mode-floating-menu/exam-mode-floating-menu.component';
import { EpubViewerOverlayComponent } from 'src/app/components/epub-viewer/epub-viewer-overlay/epub-viewer-overlay.component';
import { EpubAnnotationsFloatingMenuComponent } from 'src/app/components/floating-menus/epub-annotations-floating-menu/epub-annotations-floating-menu.component';

@Component({
    selector: 'asg-layout',
    templateUrl: './layout.component.html',
    styleUrls: ['./layout.component.scss'],
    standalone: true,
    imports: [NgClass, DropdownComponent, TooltipDirective, MenuItemAdjusterDirective, DesktopMenuItemComponent, ReadingToolbarComponent, PaneListComponent, ToolbarFloatingMenuComponent_1, SpeechRecognitionFloatingMenuComponent, DrawingToolsFloatingMenuComponent_1, SearchFloatingMenuComponent, HighlighterFloatingMenuComponent_1, EpubAnnotationsFloatingMenuComponent, MarkUpFloatingMenuComponent, WordPredictorDialogComponent, AsgardCustomInputIframeComponent, KeyboardEventHandlerComponent, ExamTamperProtectionComponent, KeyInfoComponent, ExamModeFloatingMenuComponent, EpubViewerOverlayComponent]
})
export class LayoutComponent implements OnInit, OnDestroy {
  private readonly subscriptions: Subscription = new Subscription();

  AsgardFeatureNames: typeof AsgardFeatureNames = AsgardFeatureNames;
  ModalWindowsTypes: typeof ModalWindowsTypes = ModalWindowsTypes;
  uiState: CurrentUIState & { [key: string]: any } | null = null;
  mainMenu: RootMenuItem[];
  toolsMenu: RootMenuItem[];
  readingMenu: RootMenuItem | undefined;
  toolbar: RootMenuItem | undefined;
  textSettingsBar: RootMenuItem | undefined;
  highlightBar: RootMenuItem | undefined;
  epubBar: RootMenuItem | undefined;
  drawingTools: RootMenuItem | undefined;
  speechRecognition: RootMenuItem | undefined;
  search: RootMenuItem | undefined;
  langMenu: RootMenuItem[];
  examModeMenu: RootMenuItem | undefined;
  settingsMenu: RootMenuItem[];
  collapsedFeaturesMenu: RootMenuItem[];
  textStylingMenu: RootMenuItem;
  isExamModeAccessible = false;
  isSiteAdmin = false;
  isBrowserSupported = false;

  // ASG-962
  hideDrawingTools: boolean = false;

  // @ViewChild('sidenav', { static: false }) sidenav: MatDrawer;
  @ViewChild(ToolbarFloatingMenuComponent) toolbarFloatingMenu: ToolbarFloatingMenuComponent;
  @ViewChild(DrawingToolsFloatingMenuComponent) drawingToolsFloatingMenu: DrawingToolsFloatingMenuComponent;
  @ViewChild(HighlighterFloatingMenuComponent) highlighterFloatingMenu: HighlighterFloatingMenuComponent;

  private unsavedChanged: boolean = true;
  public examRestrictionsAreActive = this.examService.isExamInProgress;

  @HostListener('window:beforeunload')
  canDeactivate(): Observable<boolean> | boolean {
    return !this.unsavedChanged && !this.examService.notAllowedToCloseBrowserTab;
  }

  constructor(
    public menuService: MenuService,
    public uiService: CurrentUiStoreService,
    public settingsSvc: SettingsService,
    private readingModeService: ReadingModesService,
    private autosave: AutosaveManagerService,
    private deviceDetectorService: DeviceDetectorService,
    private examService: ExamModeRestrictionsService,
    private readonly licenseService: LicenseService,
    private readonly examCommService: ExamCommunicationService,
    private readonly authService: AuthService,
    private readonly accountService: AccountService,
    private platform: PlatformDetectionService,
  ) {
    this.isBrowserSupported = this.platform.isBrowserSupported;
    
    this.licenseService.isExamModeAccessible()
      .then((result) => {
        this.isExamModeAccessible = result;

        if (result) {
          this.menuService.setWidthsForMenuItemsForStapAddOn();
          this.examCommService.initialize(this.authService.getToken.bind(this.authService));
        }
      });
  }

  async ngOnInit(): Promise<void> {
    this.subToUIState();

    // get settings from here instead of the auth guard
    await this.settingsSvc.getUserSettings();

    // site admins do not have access to eXamode
    // but supervisor/site admins should have access to eXamode
    const userAccount = await this.accountService.getAccountInfo();
    if (userAccount) {
      const userClaims = userAccount?.roles;
      const isSiteAdmin = userClaims.includes(CerberusRoles.SiteAdmin);
      const isSupervisor = userClaims.includes(CerberusRoles.Supervisor);
      this.isSiteAdmin = isSiteAdmin && !isSupervisor;
    } else {
      console.error('No userAccount found to check roles');
    }

    this.subToMenu();
    this.subToReadingmodeSettings();

    this.subscriptions.add(
      this.examService.isExamInProgress$.subscribe(isActive => this.examRestrictionsAreActive = isActive)
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private subToMenu(): void {
    this.mainMenu = this.menuService.getMainMenuElements();
    this.toolsMenu = this.menuService.getToolsMenuElements();
    this.readingMenu = this.menuService.getReadingControlMenuItems();
    this.toolbar = this.menuService.getToolbarMenuItem();
    this.textSettingsBar = this.menuService.getTextToolsMenuItem();
    this.highlightBar = this.menuService.getHighlightsMenuItem();
    this.epubBar = this.menuService.getEpubMenuItem();
    this.drawingTools = this.menuService.getDrawingToolsMenuItem();
    this.speechRecognition = this.menuService.getSRMenuItem();
    this.search = this.menuService.getSearchMenuItem();
    this.langMenu = this.menuService.getLangsMenuItems();
    this.examModeMenu = this.menuService.getExamModeMenuItem();
    this.settingsMenu = this.menuService.getSettingsMenuItems();
    this.collapsedFeaturesMenu = this.menuService.getCollapsedMenuItems();
    // console.log(this.mainMenu, 'this.mainMenu');
    // console.log(this.collapsedFeaturesMenu, 'this.collapsedFeaturesMenu');
    // console.log('getMenuElements');
  }

  private subToUIState(): void {
    this.subscriptions.add(
      this.uiService.getUIState()
        .subscribe((e: CurrentUIState) => {
          this.uiState = e as any;
          // if (this.sidenav && this.sidenav.opened) {
          //   this.sidenav.opened = false;
          // }
        })
    );

    this.subscriptions.add(
      this.autosave.unsavedChangesSubj.subscribe(e => {
        this.unsavedChanged = e;
      })
    );

    this.subscriptions.add(
      this.menuService.menuItemsUpdated.subscribe(() => {
        this.subToMenu();
      })
    );
    this.subscriptions.add(
      this.deviceDetectorService.deviceScreenDimensions$.subscribe((e: ScreenDimensions) => {
        // if screen width gets below 704px, remove all markup tools from screen
        if (e.width <= ResponsiveUIBreakpoints.markupTools) {
          this.removeMarkupToolsFloatingMenu();
        }

        // if screen width gets below 704px, remove all markup tools from screen
        if (e.width <= ResponsiveUIBreakpoints.ToolsMenu) {
          this.relocateToolsMenuToMainMenu();
        } else {
          this.relocateToolsFromMainMenuToToolsMenu();
        }

        // compare height to width to know if the main menu should be small or normal
        const widths = [ResponsiveUIBreakpoints.logout,
        ResponsiveUIBreakpoints.settings,
        ResponsiveUIBreakpoints.speechRecognition,
        ResponsiveUIBreakpoints.ToolsMenu];
        const heights = [ResponsiveUIBreakpoints.smallMainMenuLogout,
        ResponsiveUIBreakpoints.smallMainMenuSettings,
        ResponsiveUIBreakpoints.smallMainMenuSpeechRecognition,
        ResponsiveUIBreakpoints.smallMainMenuToolsMenu];
        let useSmall = false;

        // if the height is smaller then a breakpoint and the width is also smaller then the same breakpoint, then the small main menu should be displayed
        // for example, if the sign_out was added to the main menu
        // then the width is smaller then .logout
        // if the height then is smaller then .smallMainMenuLogout as well, the small main menu should be displayed.
        for (let i = 0; i < widths.length; i++) {
          const width = widths[i];
          const height = heights[i];
          if (e.width < width && e.height < height) {
            useSmall = true;
          }
        }

        // if height is smaller then minimum, use small main menu
        if (e.height < ResponsiveUIBreakpoints.smallMainMenu || useSmall) {
          this.menuService.setDisplaySmallMainMenu(true);
        } else {
          this.menuService.setDisplaySmallMainMenu(false);
        }

        // if the width gets smaller then 440 pixels and the small menu is displayed,
        // do no longer display titles in the main menu, just the icon
        this.menuService.toggleDisplaySmallMainMenu(e.width <= ResponsiveUIBreakpoints.smallMainMenuIconOnly && useSmall);
      })
    );
  }

  private subToReadingmodeSettings(): void {
    this.subscriptions.add(
      this.readingModeService.globalReadingModeObservable
        .subscribe((r: ReadingMode) => {
          if (this.textSettingsBar) {
            switch (r) {
              case ReadingMode.ClickToPlay:
                this.textSettingsBar.icon = 'fas fa-mouse-pointer';
                break;
              case ReadingMode.ClickToRead:
                this.textSettingsBar.icon = 'fas fa-bullseye-pointer';
                break;
              case ReadingMode.Selection:
                this.textSettingsBar.icon = 'fas fa-font';
                break;
              case ReadingMode.Hover:
                this.textSettingsBar.icon = 'far fa-hand-pointer';
                break;
              case ReadingMode.RectangleSelection:
                this.textSettingsBar.icon = 'far fa-object-group';
                break;
              default: return;
            }
          }
        })
    );
  }

  private removeMarkupToolsFloatingMenu(): void {
    if (this.toolbarFloatingMenu) { this.toolbarFloatingMenu.close(); }
    if (this.drawingToolsFloatingMenu) { this.drawingToolsFloatingMenu.close(); }
    if (this.highlighterFloatingMenu) { this.highlighterFloatingMenu.close(); }
  }

  private relocateToolsMenuToMainMenu(): void {
    if (!this.toolsMenu) {
      this.toolsMenu = this.menuService.getToolsMenuElements();
    }

    this.toolsMenu.forEach(tool => this.menuService.addMenuItemToBurger(tool.feature));
  }

  private relocateToolsFromMainMenuToToolsMenu(): void {
    if (this.toolsMenu) {
      this.toolsMenu.forEach(tool => this.menuService.removeItemFromBurger(tool.feature));
      // TODO need a better way to determine whether the title should be displayed or not
      this.toolsMenu.forEach(tool => tool.isChild = true);
    }
  }
}
